import { httpRequest } from '../../shared/lib/utils/httpClient';
import { rowsPerPage } from '../../pages/constants';

export interface IntakeFormList {
  totalRecords: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  intakeFormList: IntakeForm[];
}

export interface IntakeForm {
  id: number;
  intakeFormName: string | null;
  intakeFormBusinessId: string | null;
  assignedFacility: number;
  pid: string | null;
  createdOn: string | null;
  modifiedOn: string | null;
  default: boolean;
}

export interface IntakeFormListddl {
  id: number;
  name: string;
}

export interface FacilityMappingList {
  intakeFormId: number;
  intakeFormName: string | null;
  assignedFacilities: FacilityMapping[];
  allAvailableFacilities: FacilityMapping[];
}

export interface FacilityMapping {
  id: number;
  name: string;
  intakeFormName: string | null;
}

export interface DefaultIntakeForm {
  intakeFormId: number;
  defaultIntakeForm: boolean;
}

export interface DefaultIntakeFormResponse {
  code: number;
  status: string;
  message: string;
}

export interface UpdateMappingList {
  intakeFormId: number;
  assignedFacilities: number[];
}

export interface SessionFields {
  id: number;
  fieldName: string;
  fieldLabel: string;
  fieldValues: string | number;
}

export interface FacilityFields {
  id: number;
  name: string;
}

export interface FieldTypes {
  id: number;
  name: string;
}

export interface IntakeMetaData {
  sessionFields: SessionFields[];
  facilityFields: FacilityFields[];
  fieldTypes: FieldTypes[];
}

export interface AdditionalSessionFieldRowData {
  id: number;
  additionalSessionId: number;
  fieldName: string;
  fieldType: number;
  fieldValue: string;
  displayOnTile: boolean;
  mandatory: boolean;
}

export interface SaveIntakeFormData {
  intakeFormId: number;
  intakeFormName: string;
  intakeFormBusinessId: string;
  sessionFields: SessionFields[];
  additionalSessionFields: AdditionalSessionFieldRowData[];
  facilityFields: FacilityFields[];
}

export const getIntakeFormList = async (
  userId: string,
  page: number = 0,
  size: number = rowsPerPage,
  sortField?: string,
  sortType?: string,
  searchTerm?: string,
  facilityId?: number[]
): Promise<IntakeFormList> => {
  const params: Record<string, string | number> = {
    page,
    size,
  };

  if (sortField) params.sortField = sortField;
  if (sortType) params.sortType = sortType;
  if (searchTerm) params.searchTerm = searchTerm;
  if (facilityId) params.facilityId = facilityId.join(',');

  const response = await httpRequest<IntakeFormList>({
    method: 'GET',
    url: '/operation/intake-forms',
    params,
    headers: { userId },
  });
  return response;
};

export const getFacilityMappingList = async (
  userId: string,
  intakeFormId: number
): Promise<FacilityMappingList> => {
  const response = await httpRequest<FacilityMappingList>({
    method: 'GET',
    url: `/operation/intake-form/mapFacilities?intakeFormId=${intakeFormId}`,
    headers: { userId },
  });
  return response;
};

export const updateDefaultIntakeForm = async (
  userId: string,
  payload: DefaultIntakeForm
): Promise<DefaultIntakeFormResponse> => {
  const response = await httpRequest<DefaultIntakeFormResponse>({
    method: 'PUT',
    url: `/operation/intake-form/default`,
    headers: { userId },
    data: payload,
  });
  return response;
};

export const updateIntakeFormMapping = async (
  userId: string,
  payload: UpdateMappingList
): Promise<DefaultIntakeFormResponse> => {
  const response = await httpRequest<DefaultIntakeFormResponse>({
    method: 'PUT',
    url: `/operation/intake-form/mapFacilities`,
    headers: { userId },
    data: payload,
  });
  return response;
};

export const getIntakeformMetaData = async (
  userId: string
): Promise<IntakeMetaData> => {
  const response = await httpRequest<IntakeMetaData>({
    method: 'GET',
    url: `/operation/intake-form/metadata`,
    headers: { userId },
  });
  return response;
};

export const getIntakeFormListForddl = async (
  userId: string
): Promise<IntakeFormListddl[]> => {
  const response = await httpRequest<IntakeFormListddl[]>({
    method: 'GET',
    url: `/operation/intake-forms/dropdown`,
    headers: { userId },
  });
  return response;
};

export const saveintakeform = async (
  userId: string,
  action: string,
  payload: SaveIntakeFormData
) => {
  const apiAction = action === 'Save' ? 'SAVE' : 'UPDATE';
  const response = await httpRequest<SaveIntakeFormData>({
    method: 'PUT',
    url: `/operation/intake-form?action=${apiAction}`,
    headers: { userId },
    data: payload,
  });
  return response;
};

export const getIntakeFormbyId = async (
  userId: string,
  formId: number
): Promise<SaveIntakeFormData> => {
  const response = await httpRequest<SaveIntakeFormData>({
    method: 'GET',
    url: `/operation/intake-form?intakeFormId=${formId}`,
    headers: { userId },
  });
  return response;
};

export const deleteIntakeForm = async (
  userId: string,
  formId: number
): Promise<DefaultIntakeFormResponse> => {
  const response = await httpRequest<DefaultIntakeFormResponse>({
    method: 'DELETE',
    url: `/operation/intake-form?intakeFormId=${formId}`,
    headers: { userId },
  });
  return response;
};
